// 🚨 AUTO-GENERADO desde RecibeDataType.ts - No editar manualmente

export const RecibeFormDataKeys = [
  "id",
  "numero",
  "total",
  "abono",
  "motivo",
  "nombre",
  "created",
  "forma_pago",
  "exchange_rate",
  "reference",
  "digitosTarjeta",
  "numAprobacion",
  "anulado",
  "clientId",
  "client",
  "currencyId",
  "currency",
  "creditOperatorId",
  "creditOperator",
  "bankAccountId",
  "bankAccount",
  "invoices",
  "invoicePayments",
  "settlements",
  "settlementPayments",
  "interestEntries",
  "user"
] as const;
